import React from "react";
import { Box, Heading, Select } from "@chakra-ui/react";
const Header = () => {
  return (
    <Box w="616px" h="24px">
      <Heading fontSize="18px" color="#12344D" fontWeight="600">
        Integrate CRM
      </Heading>
    </Box>
  );
};

export default Header;
